import { render, staticRenderFns } from "./formControlItem.vue?vue&type=template&id=67b2331e"
import script from "./formControlItem.vue?vue&type=script&lang=js"
export * from "./formControlItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67b2331e')) {
      api.createRecord('67b2331e', component.options)
    } else {
      api.reload('67b2331e', component.options)
    }
    module.hot.accept("./formControlItem.vue?vue&type=template&id=67b2331e", function () {
      api.rerender('67b2331e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/examine/formControlItem.vue"
export default component.exports